import React from "react";

import ForgotPasswordForm from "../Forms/ForgotPassword";
import "./Login.scss";

const ForgotPasswordPage = () => {
	const doSendResetPasswordEmail = (values) => {
		console.log("values ", values);
	};

	return (
		<div className="form-page-container forgot-password-page">
			<div className="form-page-box">
				<div className="form-page-header">
					<h2 className="form-page-header-title">Reset Password</h2>
				</div>
				<div className="form-page-content">
					<ForgotPasswordForm onSubmit={doSendResetPasswordEmail} />
				</div>
			</div>
		</div>
	);
};

export default ForgotPasswordPage;
